export default __webpack_public_path__ + "static/media/jingle-wonderland-spell.504c8361.gif";